// AUTO-GENERATED by app-config-utils/generateFontsFile — do not edit by hand.
// Regenerated on each build/dev from the store's settings.layout.fonts.
import { Playfair_Display, Libre_Baskerville, Grape_Nuts } from 'next/font/google'

const playfairDisplay = Playfair_Display({
  subsets: ['latin', 'latin-ext'],
  weight: ['400', '500', '600', '700', '800', '900']
})

const libreBaskerville = Libre_Baskerville({
  subsets: ['latin', 'latin-ext'],
  weight: ['400', '700']
})

const grapeNuts = Grape_Nuts({
  subsets: ['latin', 'latin-ext'],
  weight: ['400']
})

export const fonts = {
  heading: playfairDisplay.style.fontFamily,
  body: libreBaskerville.style.fontFamily,
  slogan: grapeNuts.style.fontFamily
}
